export const formatRuleId = (ruleId?: string): string => {
  return ruleId ? `#${ruleId.slice(-4)}` : '';
};
